module.exports = __webpack_public_path__ + "static/img/SSL.13fea0e4.svg";